import { FC } from 'react';
import MinkaList from './MinkaList';
import UseMinkaList from './UseMinkaList';

const MinkaListContainer: FC = () => {
  return <MinkaList {...UseMinkaList()} />;
};

export default MinkaListContainer;
